import { EyeIcon } from "@images/svgIcons/eyeIcon"
import { SlashedEyeLineIcon } from "@images/svgIcons/slashedEyeLineIcon"
import { word } from "@modules/core/utils/i18n"
import { HUButton } from "@modules/ui/components/huButton"
import { HUText } from "@modules/ui/components/huText"
import { HURow } from "@modules/ui/components/layout"
import { classNames } from "primereact/utils"
import { useTheme } from "styled-components"

type ProfileLabelVisibilityProps = {
  name: string
  label: string
  isInvalid?: boolean
  isRequiredInput?: boolean
  displayVisibleToggle?: boolean
  visibility?: boolean
  onToggleVisibility?: () => void
}

export const ProfileLabelVisibility: React.FC<ProfileLabelVisibilityProps> = ({
  name,
  label,
  isInvalid,
  isRequiredInput,
  displayVisibleToggle,
  visibility,
  onToggleVisibility,
}) => {
  const theme = useTheme()

  return (
    <HURow className="justify-content-between align-items-center">
      <HUText
        type="label"
        color={theme.inputLabelColor}
        fontStyle="LS"
        className={classNames({ "p-error": isInvalid })}
        textProps={{ htmlFor: name }}
        style={{ lineHeight: "21px" }}
      >
        {label.toUpperCase()}
        {isRequiredInput && (
          <HUText fontStyle="LL" color={theme.necessaryInput}>
            {" "}
            *
          </HUText>
        )}
      </HUText>

      {/* Visibility toggle button */}
      {displayVisibleToggle && (
        <HUButton
          colorType="Tertiary"
          size="XS"
          type="Rounded"
          className="border-transparent"
          tooltipContent={word("profile.form.visibility.tooltip")}
          isTooltipDisabled={false}
          tooltipId={"visibility" + name}
          icon={{
            iconView: visibility ? (
              <EyeIcon color={theme.neutralColor600} width={24} height={24} />
            ) : (
              <SlashedEyeLineIcon color={theme.neutralColor600} width={24} height={24} />
            ),
          }}
          onClick={() => onToggleVisibility?.()}
        />
      )}
    </HURow>
  )
}
